import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function ComercializadoraAnexo21y22RMF2026ProgramaInformatico() {
  return (
    <CategoryPage
      category="comercializadoraAnexo21Y22Rmf2026ProgramaInformatico2026"
      pageTitle="Programa Informatico 2026"
    />
  );
}

export default ComercializadoraAnexo21y22RMF2026ProgramaInformatico;
